import MazeGame from './MazeGame.vue';
import MazeGameList from './MazeGameList.vue';
export default {
  MazeGame,
  MazeGameList,
};
